import React, { useEffect, useState } from "react";
import {
  useSearchParams,
  useNavigate,
  Link,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";
import * as SettingSelector from "../../../store/setting/selectors";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import LoginIcon from "@mui/icons-material/Login";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// Images / media
import AXIOSCONFIGMETHOD from "../../../components/apiCall/axiosConfig";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner";
import image1 from "../../../assets/images/loginImages/image1.webp";
import image2 from "../../../assets/images/loginImages/image2.webp";
import image3 from "../../../assets/images/loginImages/image3.webp";
import image4 from "../../../assets/images/loginImages/image4.webp";
import image5 from "../../../assets/images/loginImages/image5.webp";
import image6 from "../../../assets/images/loginImages/image6.webp";
import image7 from "../../../assets/images/loginImages/image7.webp";
import image8 from "../../../assets/images/loginImages/image8.webp";
import image9 from "../../../assets/images/loginImages/image9.webp";
import image10 from "../../../assets/images/loginImages/image10.webp";
import image11 from "../../../assets/images/loginImages/image11.jpeg";
import image12 from "../../../assets/images/loginImages/image12.webp";
import image13 from "../../../assets/images/loginImages/image13.webp";
import image14 from "../../../assets/images/loginImages/image14.webp";
import image15 from "../../../assets/images/loginImages/image15.webp";
import image16 from "../../../assets/images/loginImages/image16.webp";
import image17 from "../../../assets/images/loginImages/image17.jpeg";
import image18 from "../../../assets/images/loginImages/image18.jpeg";
import image19 from "../../../assets/images/loginImages/image19.jpeg";
import image20 from "../../../assets/images/loginImages/image20.jpeg";
import image21 from "../../../assets/images/loginImages/image21.jpeg";
import image22 from "../../../assets/images/loginImages/image22.jpeg";
import image23 from "../../../assets/images/loginImages/image23.webp";

let arrayOfImages = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
  image19,
  image20,
  image21,
  image22,
  image23,
];


const logo = "/assets/logo/ihfc_logo.png";
// Base cell size used to calculate how many tiles are needed to cover the screen
const CELL_SIZE_DESKTOP = 120;
const CELL_SIZE_MOBILE = 70;
const MOBILE_BREAKPOINT = 480;

// How tile spans repeat: 0 = normal (1x1), 1 = wide/landscape (2x1), 2 = tall/portrait (1x2)
const getSpanType = (idx) => idx % 5;

const calcGridDims = () => {
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  const cellSize = isMobile ? CELL_SIZE_MOBILE : CELL_SIZE_DESKTOP;

  // +2 buffer so rounding never leaves a gap at the edges
  const cols = Math.ceil(window.innerWidth / cellSize) + 2;
  const rows = Math.ceil(window.innerHeight / cellSize) + 2;

  return { cols, rows, cellCount: cols * rows };
};

const SignIn = () => {
  const [query] = useSearchParams();
  const emailParams = query.get("email");
  const appName = useSelector(SettingSelector.app_name);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [lastLogin, setLastLogin] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [debounceValue, setDebounceValue] = useState("");
  const [pageLoading, setpageLoading] = useState(false);
  const [gridDims, setGridDims] = useState(() =>
    typeof window !== "undefined"
      ? calcGridDims()
      : { cols: 10, rows: 10, cellCount: 100 },
  );

  const location = useLocation();
  console.log(location?.search?.split("=")[1], "pressings");

  const schoolCodeParams = query.get("school_code");


  useEffect(() => {

    // if(!emailParams) navigate("/auth/register")

    console.log("Response :", emailParams)
    if (emailParams !== null && emailParams !== undefined) {
      try {
        setEmail(atob(emailParams) ?? "");
      } catch (e) {
        console.error("Invalid base64 string:", emailParams, e);
        setEmail("");
      }
    } else {
      setEmail("");
    }
  }, [emailParams]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(email);
    }, 500);
    return () => clearTimeout(handler);
  }, [email]);

  // useEffect(() => {
  //   if (debounceValue) {
  //     getLastLogin();
  //   }
  // }, [debounceValue, lastLogin]);

  // Recalculate the grid to always fully cover the viewport on resize
  useEffect(() => {
    const handleResize = () => {
      setGridDims(calcGridDims());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getLastLogin = async () => {
    try {
      const resp = await AXIOSCONFIGMETHOD("post", webServiceUrl.firstLogin, {
        email: debounceValue,
      });
      if (resp?.success && resp?.last_login !== undefined) {
        setLastLogin(resp?.last_login);
      } else {
        setLastLogin(null);
      }
    } catch (error) {
      console.error(error);
      setLastLogin(null);
    }
  };

  const signInApi = async (e) => {
    e.preventDefault();
    setError("");
    setpageLoading(true);

    try {
      // let encoded = localStorage.getItem("encoded");
      const decoded = atob(decodeURIComponent(location?.search?.split("=")[1]));
      const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.login, {
        username: email,
        password: password,
        school_code: decoded,
      });

      if (response.success === true) {
        const user = response?.data;

        // Validate the school_code matches what you expect
        // if (!user || user?.school_code !== encoded) {
        //   toast.error("User doesn't exist in Platform");
        //   return;
        // }
        setpageLoading(false);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("school_code", user.school_code);
        localStorage.setItem("phone", email);
        localStorage.setItem("isFormFilled", user.isFormFilled);
        localStorage.setItem("userId", user?.student?.student_id);
        localStorage.setItem("name", user?.student?.name);
        localStorage.setItem("username", user?.student?.name);
        localStorage.setItem("token", response.token);
        localStorage.setItem("email", user?.student?.email);
        localStorage.setItem("is_lead", user?.student?.isLead);
        localStorage.setItem("group_id", user?.student?.group_id);
        toast.success("Login successful!");
        setTimeout(() => {
          if (user.isFormFilled) {
            localStorage.setItem("login", "true");
            navigate("/");
          } else {
            navigate("/online-reg");
          }
        }, 1000);
        setpageLoading(false);
      } else {
        toast.error(response?.message || "Login failed");
        setpageLoading(false);
      }
    } catch (err) {
      console.log("Login failed:", err.message);
      toast.error(err.message);
      setpageLoading(false);
    }
  };

  // Build extra tiles (over-provision a bit since spanning tiles eat more than one cell)
  const overProvisionedCount = Math.ceil(gridDims.cellCount * 1.6);
  const tiles = Array.from({ length: overProvisionedCount }).map((_, idx) => ({
    src: arrayOfImages[idx % arrayOfImages.length],
    span: getSpanType(idx),
  }));


  const isInvalidSchoolCode = (value) => {
    return (
      !value ||
      value === "null" ||
      value === "undefined" ||
      value.trim() === ""
    );
  };


  useEffect(() => {
    const schoolCode = query.get("school_code");

    if (isInvalidSchoolCode(schoolCode)) {
      navigate("/auth/register", { replace: true });
      return;
    }

    try {
      const decoded = atob(decodeURIComponent(schoolCode));

      if (!decoded || decoded === "null" || decoded === "undefined") {
        navigate("/auth/register", { replace: true });
        return;
      }

      console.log("Valid school code:", decoded);
    } catch (error) {
      console.error("Invalid school_code:", error);
      navigate("/auth/register", { replace: true });
    }
  }, [query, navigate]);



  return (
    <section className="sign-in-page" id="login-in-page">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700&display=swap');

        #login-in-page * {
          font-family: 'Roboto', sans-serif;
        }

        /* ---------- Full-page wrapper, box centered ---------- */
        #login-in-page {
          width: 100%;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px 16px;
          position: relative;
        }

        /* ---------- Grid gallery: locked to viewport, some tiles wide, some tall ---------- */
        .bg-image-grid {
          position: fixed;
          inset: 0;
          display: grid;
          grid-template-columns: repeat(${gridDims.cols}, 1fr);
          grid-auto-rows: ${window.innerWidth <= MOBILE_BREAKPOINT ? CELL_SIZE_MOBILE : CELL_SIZE_DESKTOP}px;
          grid-auto-flow: dense;
          gap: 3px;
          overflow: hidden;
          z-index: 0;
        }

        .bg-image-grid img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          opacity: 0.9;
        }

        .bg-image-grid .tile-wide {
          grid-column: span 2;
        }

        .bg-image-grid .tile-tall {
          grid-row: span 2;
        }

        /* Optional dark overlay so the box stays readable over the image grid */
        #login-in-page::before {
          content: "";
          position: fixed;
          inset: 0;
          background: rgba(9, 40, 24, 0.55);
          z-index: 1;
          pointer-events: none;
        }

        /* ---------- Sign-in box: centered, compact ---------- */
        .sign-in-form-col {
          position: relative;
          z-index: 2;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .sign-in-box {
          width: 100%;
          max-width: 420px;
          text-align: center;
          background: rgba(255, 255, 255, 0.82);
          border-radius: 16px;
          padding: 28px 24px;
          box-shadow: 0 20px 48px rgba(9, 40, 24, 0.28);
        }

         .sign-in-box .logo-wrap {
        //   width: 64px;
        //   height: 64px;
        //   margin: 0 auto 14px;
        //   border-radius: 50%;
        //   background: #eafaf0;
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
         }

        // .sign-in-box .logo-wrap img {
        //   width: 42px;
        //   height: 42px;
        //   object-fit: contain;
        // }

        .sign-in-box h4 {
          color: #14532d;
          font-weight: 700;
          font-size: clamp(18px, 4vw, 21px);
          margin-bottom: 4px;
        }

        .sign-in-box .subtitle {
          color: #6b7280;
          font-size: 12.5px;
          margin-bottom: 22px;
        }

        .input-field {
          text-align: left;
          margin-bottom: 16px;
        }

        .input-field label {
          display: block;
          color: #374151;
          font-weight: 600;
          font-size: 12.5px;
          margin-bottom: 6px;
        }

        .input-wrap {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #f5f7f6;
          border: 1.5px solid #e2e5e4;
          border-radius: 10px;
          padding: 0 12px;
          height: 44px;
          transition: border-color 0.2s ease, background 0.2s ease;
        }

        .input-wrap:focus-within {
          border-color: #16a34a;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.12);
        }

        .input-wrap .field-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #16a34a;
        }

        .input-wrap .field-icon svg {
          font-size: 19px;
        }

        .input-wrap input {
          flex: 1;
          min-width: 0;
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
          color: #111827;
          font-size: 14px;
          line-height: 1;
          padding: 0;
        }

        .input-wrap input::placeholder {
          color: #9ca3af;
        }

        .input-wrap .toggle-eye {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          cursor: pointer;
          color: #6b7280;
        }

        .input-wrap .toggle-eye svg {
          font-size: 18px;
        }

        .input-wrap .toggle-eye:hover {
          color: #16a34a;
        }

        .static-username {
          color: #111827;
          font-weight: 600;
          text-align: left;
          font-size: 14px;
          margin-bottom: 4px;
        }

        .forgot-row {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 16px;
        }

        .forgot-row a {
          color: #16a34a;
          font-size: 12.5px;
          font-weight: 600;
          text-decoration: none;
        }

        .forgot-row a:hover {
          text-decoration: underline;
        }

        .signin-btn {
          width: 100%;
          border: none;
          border-radius: 10px;
          padding: 12px;
          background: #16a34a;
          color: #fff;
          font-weight: 700;
          font-size: 13.5px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: background 0.2s ease, transform 0.15s ease;
        }

        .signin-btn svg {
          font-size: 18px;
        }

        .signin-btn:hover {
          background: #128a3e;
        }

        .signin-btn:active {
          transform: scale(0.98);
        }

        .error-text {
          color: #dc2626;
          font-size: 13px;
          margin-bottom: 12px;
        }

        /* ---------- Mobile: box shrinks slightly further ---------- */
        @media (max-width: 480px) {
          .sign-in-box {
            max-width: 100%;
            padding: 24px 18px;
            border-radius: 14px;
          }

          .sign-in-box .logo-wrap {
            // width: 56px;
            // height: 56px;
            display: flex;
            justify-content: center;
          }

          // .sign-in-box .logo-wrap img {
          //   width: 38px;
          //   height: 38px;
          // }
        }
      `}</style>

      {/* Background grid gallery: mix of normal, wide, and tall tiles, always covers full screen */}
      <div className="bg-image-grid">
        {tiles.map((tile, idx) => (
          <img
            key={idx}
            src={tile.src}
            alt=""
            className={
              tile.span === 1 ? "tile-wide" : tile.span === 2 ? "tile-tall" : ""
            }
          />
        ))}
      </div>

      {/* Sign-in box: fully centered on the page */}
      <div className="sign-in-form-col">
        <div className="sign-in-box">
          <div className="logo-wrap">
            <img src={logo} alt="IHFC Logo" />
          </div>
          <h4>Sign in</h4>
          <p className="subtitle">Enter your details to access your account</p>

          {error && <p className="error-text">{error}</p>}

          <form onSubmit={signInApi}>
            {/* Username / Email */}
            <div className="input-field">
              {emailParams == null || emailParams == undefined ? (
                <>
                  <label>Username</label>
                  <div className="input-wrap">
                    <span className="field-icon">
                      <PersonIcon />
                    </span>
                    <input
                      type="tel"
                      placeholder="Enter Username"
                      value={email}
                      maxLength={10}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </>
              ) : (
                <p className="static-username">
                  Username:{" "}
                  <span className="text-lowercase">{email.toLowerCase()}</span>
                </p>
              )}
            </div>

            {/* Password */}
            <div className="input-field">
              <label>Password</label>
              <div className="input-wrap">
                <span className="field-icon">
                  <LockIcon />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="toggle-eye"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </span>
              </div>
            </div>

            {/* Forgot password */}
            {lastLogin && (
              <div className="forgot-row">
                <Link to="/auth/recoverpw">Forgot Password?</Link>
              </div>
            )}

            <button type="submit" className="signin-btn">
              {pageLoading ? (
                <Oval
                  height="25"
                  width="25"
                  color="white"
                  secondaryColor="white"
                />
              ) : (
                <>
                  <LoginIcon />
                  {"Sign in"}
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ fontSize: "15px" }}
      />
    </section>
  );
};

export default SignIn;
